import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setNextFormStep, setInitialFormStep } from 'actions/form';

type FormStepState = number;
interface UseSignUpStep {
  formStep: FormStepState;
  setNextFormStepHandler: VoidFunction;
  setInitialFormStepHandler: VoidFunction;
}

const useSignUpStep = (): UseSignUpStep => {
  const formStep = useSelector<any, FormStepState>(state => state.formStep);
  const dispatch = useDispatch();
  const setNextFormStepHandler = useCallback(() => dispatch(setNextFormStep()), [dispatch]);
  const setInitialFormStepHandler = useCallback(() => dispatch(setInitialFormStep()), [dispatch]);

  useEffect(() => {
    return () => {
      setInitialFormStepHandler();
    };
  }, [setInitialFormStepHandler]);

  return {
    formStep,
    setNextFormStepHandler,
    setInitialFormStepHandler,
  };
};

export default useSignUpStep;
